
import { mapGetters } from "vuex";
import { sendAli } from "@/utils/send-ali";
import {
  getTranslateTemplate,
  getTranslateTemplateCustom,
  translateAPI,
} from "@/api";
import StyleSelector from "~/components/styleSelector.vue";
import AspectRatioSelector from "~/components/aspectRatioSelector.vue";
import AdvancedOptions from "~/components/Advancedoptions.vue";

export default {
  data() {
    return {
      //一些选项的配置
      localConfig: {
        gender: "1",
        mode: "custom", // 默认设置为custom
        prompt: "",
        inspirationIndex: -1,
        style: "default", // 默认样式
        aspectRatio: "1:1", // 默认纵横比
        bodyPart: ""   // 身体部位
      },
      genderPrompt: {
        1: "",
        2: "",
      },
      advancedOptions: {
        negativePrompt: null,
        complexity: 0.5
      },
      targetSelect: '', //存储选中的图片
      targetSelectBase64: '',
      btnDisabled: false, // 控制按钮是否被禁用，防抖
      maxUpload: 4, // 最大上传图片数
      charCount: 0, // 添加字符计数器
      selectedModel: 2, // 默认选择v2模型
    };
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
  },
  watch: {
    // 监听prompt变化
    'localConfig.prompt': {
      handler: function (newVal) {
        this.countChars();
      },
      immediate: true // 组件创建时立即执行
    }
  },
  components: { AdvancedOptions, AspectRatioSelector, StyleSelector },
  props: {
    language: null,
    lan: null,
    isMobile: null,
    isDisable: null,
    svgCode: null,
    load: null,
    isRemaker: null,
    aLiId: null,
    config: null,
  },
  methods: {
    clearEmit() {
      this.targetSelect = '';
      this.targetSelectBase64 = '';
    },
    getWarningHtml(text) {
      const regex = /\|(.*?)\|/g;
      // 获取prompt中使用|标记的字符串
      let matches = [...text.matchAll(regex)];
      // 替换字符串中目标元素，调整为加粗样式
      let showContent = text;
      matches.forEach((match) => {
        showContent = showContent.replace(
          match[0],
          `<span class="warning">${match[1]}</span>`
        );
      });
      return showContent;
    },
    onAdvancedOptionsChange(options) {
      this.advancedOptions = options;
    },
    navigateTo(path) {
      // 设置加载状态
      this.isLoading = true;

      // 确保导航栏保持可见
      document.body.classList.add('page-navigating');

      try {
        // 直接重置滚动位置
        if (this.isMobile) {
          window.scrollTo(0, 0);
        } else {
          const contentArea = document.querySelector('.content-area');
          if (contentArea) {
            contentArea.scrollTop = 0;
          }
        }

        // 进行路由导航，使用try-catch处理而不依赖Promise
        const navResult = this.$router.push(path);

        // 检查返回值是否为Promise
        if (navResult && typeof navResult.then === 'function') {
          navResult
            .then(() => {
              this.currentPath = path;
            })
            .catch(err => {
              // 只记录不是导航取消的错误
              if (err.name !== 'NavigationDuplicated') {
                console.error('Navigation error:', err);
              }
            });
        } else {
          // 如果不是Promise，直接更新当前路径
          this.currentPath = path;
        }
      } catch (err) {
        console.error('Navigation error:', err);
      }

      // 不管成功或失败，总是在适当的时间后重置状态
      setTimeout(() => {
        document.body.classList.remove('page-navigating');
      }, 300);
    },
    // 处理样式变化
    onStyleChange(style) {
      this.localConfig.style = style;
    },
    // 获取选中的style
    getStyle() {
      return this.localConfig.style || this.config.defaultStyle;
    },
    // 随机选择一个灵感内容
    getRandomInspiration() {
      const randomIndex = Math.floor(Math.random() * this.config.inspiration[this.lan].length);
      return this.config.inspiration["en"][randomIndex][this.localConfig.gender];
    },
    // 点击开始生成
    async tapGenerate(type) {
      if (this.charCount > 150) {
        sendAli(this.aLiId, "generate_image_char_limit", {
          style: this.localConfig.style,
          aspectRatio: this.localConfig.aspectRatio,
          bodyPart: this.localConfig.bodyPart,
          payment: this.getUserInfo.payment ? 1 : 2,
          prompt: this.localConfig.prompt
        });
        await this.$alert(this.$t('wordLimitExceeded'), this.$t('notice'), {
          confirmButtonText: this.$t('sure')
        });
        return;
      }
      // 显示加载状态
      this.$root.$emit('content-loading');

      this.btnDisabled = true;
      setTimeout(() => {
        this.btnDisabled = false;
      }, 5000);

      let param = {};

      // 设置prompt
      if (this.localConfig.prompt) {
        param.prompt = this.localConfig.prompt;
        sendAli(this.aLiId, "generate_custom", {
          prompt: param.prompt,
          payment: this.getUserInfo.payment ? 1 : 2,
        });
      }

      // 图片比例一定有
      if (type === 1) {
        // v1 模型仅支持宽高像素数据
        const aspectDimensions = this.getAspectRatioDimensions(this.localConfig.aspectRatio);
        param.width = aspectDimensions.width;
        param.height = aspectDimensions.height;
      } else {
        // v2 模型仅支持宽高比
        param.aspect_ratio = this.localConfig.aspectRatio
      }

      // 如果有身体部位，传进去
      if (this.localConfig.bodyPart !== "")
        param.bodyPart = this.localConfig.bodyPart;

      // 如果有高级选项
      if (this.advancedOptions.negativePrompt !== null) {
        this.localConfig.negativePrompt = this.advancedOptions.negativePrompt;
      }
      if (this.advancedOptions.complexity !== 0.5) {
        this.localConfig.complexity = this.advancedOptions.complexity;
      }

      const sendParams = {
        model_type: type === 1 ? "v1" : "v2",
        style: this.localConfig.style,
        aspectRatio: this.localConfig.aspectRatio,
        bodyPart: this.localConfig.bodyPart,
        payment: this.getUserInfo.payment ? 1 : 2,
        prompt: this.localConfig.prompt
      };

      // 如果有负面提示词，则添加到参数中
      if (this.localConfig.negativePrompt) {
        sendParams.negativePrompt = this.localConfig.negativePrompt;
      }

      // 如果有复杂度设置，则添加到参数中
      if (this.localConfig.complexity !== undefined) {
        sendParams.complexity = this.localConfig.complexity;
      }

      sendAli(this.aLiId, "generate_image", sendParams);

      // 将参数传到父组件来发起请求
      this.$emit("generateEmit", param, this.localConfig, type);
    },
    async translate(input, lan) {
      // 将中文提示语翻译为英文
      let raw = "";
      let text_list = [];
      text_list.push(input);
      if (typeof lan != "undefined") {
        raw = JSON.stringify(getTranslateTemplateCustom(text_list, lan));
      } else {
        raw = JSON.stringify(getTranslateTemplate(text_list));
      }
      const result = await translateAPI(raw);
      // 获取翻译后的结果，并封装AI绘图接口参数
      let arr = JSON.parse(result).auto_translation;
      let output = arr.toString();
      return output;
    },
    // 点击生成灵感
    tapInspiration() {
      sendAli(this.aLiId, "click_Inspiration");
      let index = this.localConfig.inspirationIndex;
      index += 1;
      if (index >= this.config.inspiration[this.lan].length) {
        index = 0;
      }
      this.localConfig.inspirationIndex = index;
      this.localConfig.prompt =
        this.config.inspiration["en"][index][this.localConfig.gender];
    },
    // 通知内容已加载完成
    notifyContentLoaded() {
      this.$root.$emit('content-loaded');
    },
    // 处理从templates页面传来的提示词
    handleTemplatePrompt(prompt) {
      // 设置提示词
      if (prompt) {
        this.localConfig.prompt = prompt;
      }

      // 通知内容已更新
      this.$nextTick(() => {
        this.notifyContentLoaded();
      });
    },

    // 检查localStorage是否有Custom模式标志
    checkLocalStorageForCustomMode() {
      const useCustomMode = localStorage.getItem('useCustomMode');
      const customPrompt = localStorage.getItem('customPrompt');

      if (useCustomMode === 'true' && customPrompt) {
        // 如果标志存在，直接设置提示词
        this.handleTemplatePrompt(customPrompt);
        // 清除标志，防止重复触发
        localStorage.setItem('useCustomMode', 'false');
      }
    },
    // 处理比例和身体部位选项
    onOptionChange(option) {
      if (option.type === "ratio") {
        this.localConfig.aspectRatio = option.value;
      } else if (option.type === "bodyPart") {
        this.localConfig.aspectRatio = option.ratio;
        this.localConfig.bodyPart = option.value;
      }
    },
    // 根据纵横比获取具体宽高尺寸
    getAspectRatioDimensions(ratio) {
      // 根据比例返回对应的宽高
      switch (ratio) {
        case "1:1":
          return { width: 1024, height: 1024 };
        case "2:3":
          return { width: 1024, height: 1536 };
        case "3:2":
          return { width: 1024, height: 680 };
        case "1:2":
          return { width: 1024, height: 2048 };
        default:
          return { width: 1024, height: 1024 }; // 默认为1:1
      }
    },
    // 处理从模板传来的风格选择
    handleTemplateStyle(style) {
      if (style && this.$refs.styleSelector) {
        this.$refs.styleSelector.selectStyle(style);
      } else {
        // 如果styleSelector还没准备好，暂存风格信息等待后续处理
        this.localConfig.style = style;
      }
    },

    // 检查localStorage是否有风格选择
    checkLocalStorageForStyle() {
      const selectedStyle = localStorage.getItem('selectedStyle');
      if (selectedStyle) {
        this.handleTemplateStyle(selectedStyle);
        // 清除标志，防止重复触发
        localStorage.removeItem('selectedStyle');
      }
    },
    // 计算字符数的方法
    countChars() {
      const text = this.localConfig.prompt.trim();
      this.charCount = text ? text.length : 0;
    },
  },
  mounted() {
    // 监听从templates页面传过来的事件
    this.$root.$on('use-template-prompt', this.handleTemplatePrompt);

    // 监听从index页面强制设置Custom模式的事件
    this.$root.$on('force-custom-mode', this.handleTemplatePrompt);

    // 监听风格选择事件
    this.$root.$on('use-template-style', this.handleTemplateStyle);

    // 组件加载完成后通知
    this.$nextTick(() => {
      this.notifyContentLoaded();

      // 组件加载后检查localStorage，作为备用机制
      this.checkLocalStorageForCustomMode();
      this.checkLocalStorageForStyle();

      // 确保初始时计算一次字符数
      this.countChars();

      // 如果prompt为空，则随机填充灵感内容
      // if (!this.localConfig.prompt) {
      //   this.localConfig.prompt = this.getRandomInspiration();
      // }
    });
  },
  beforeDestroy() {
    // 清理事件监听器
    this.$root.$off('use-template-prompt', this.handleTemplatePrompt);
    this.$root.$off('force-custom-mode', this.handleTemplatePrompt);
    this.$root.$off('use-template-style', this.handleTemplateStyle);
  }
};
